import { render, staticRenderFns } from "./AutomatorDocsIntroPage.vue?vue&type=template&id=2dfadf11&scoped=true"
import script from "./AutomatorDocsIntroPage.vue?vue&type=script&lang=js"
export * from "./AutomatorDocsIntroPage.vue?vue&type=script&lang=js"
import style0 from "./AutomatorDocsIntroPage.vue?vue&type=style&index=0&id=2dfadf11&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dfadf11",
  null
  
)

export default component.exports